import ScoreBars, {
  ScoreStrength
} from "@/components/controls/ScoreBars";
import TextField from "@/components/layouts/History/TextField";
import { referenceabilityLevelsToScoreBarsMap } from "@/entities/people/helpers";
import { PersonReferenceabilityLevel } from "@/entities/people/types";
import { getEnumTKey } from "@/utils/strings";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
}

const Referenceability: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-1 items-center">
      <ScoreBars
        score={
          referenceabilityLevelsToScoreBarsMap[Number(value)] as ScoreStrength
        }
      />
      <TextField>
        {t(
          getEnumTKey(
            "people",
            "refLevels",
            PersonReferenceabilityLevel,
            Number(value)
          )
        )}
      </TextField>
    </div>
  );
};

export default Referenceability;
